export const userRoles = [
  {
    label: 'Super Admin',
    value: 'administrator',
    name: 'admin',
  },
  {
    label: 'Dealership User',
    value: 'dealershipuser',
    name: 'dealershipuser',
  },
  {
    label: 'Car Sharing Team Lead/Trainer',
    value: 'teamlead',
    name: 'carsharing',
  },
  {
    label: 'Car Sharing 2nd Line',
    value: 'secondline',
    name: 'carsharing',
  },
  {
    label: 'Car Sharing 1st Line',
    value: 'firstline',
    name: 'carsharing',
  },
  {
    label: 'Colab Admin',
    value: 'colabAdmin',
    name: 'colab',
  },
  {
    label: 'Colab User - Restricted access',
    value: 'colabUserRestrictedAccess',
    name: 'colab',
  },
  {
    label: 'Colab User - Full access',
    value: 'colabUserFullAccess',
    name: 'colab',
  },
  {
    label: 'Connectivity Admin',
    value: 'connectivityAdmin',
    name: 'connectivity',
  },
  {
    label: 'Connectivity User-PROD',
    value: 'connectivityUserProd',
    name: 'connectivity',
  },
  {
    label: 'Connectivity User-UAT',
    value: 'connectivityUserUat',
    name: 'connectivity',
  },
  {
    label: 'Update Management Admin',
    value: 'updateManagementAdmin',
    name: 'updateManagement',
  },
  {
    label: 'Update Management-PROD',
    value: 'updateManagementProd',
    name: 'updateManagement',
  },
  {
    label: 'Update Management-UAT',
    value: 'updateManagementUat',
    name: 'updateManagement',
  },
];

export function mapValuesToLabels(value: string) {
  const role = userRoles.find(role => role.value.toLowerCase() === value.toLowerCase());
  return role ? role.label : 'Carsharing ' + value;
}
